// extracted by mini-css-extract-plugin
export default {"container":"tab-selector_container__1oLdE","tab":"tab-selector_tab__4k-sw"};